import { Api } from 'auth-advenio'
import { getCookie } from '../utils/Utils'

// This config file must be created locally. It is NOT versioned.
import { API_DOMAIN } from '../config'


/**
 * Create a new API instance
 */
const api = Api.createInstance((API_DOMAIN || 'http://api.soyadvenio.com'), 200000)
const apiWithoutTimeout = Api.createInstance((API_DOMAIN || 'http://api.soyadvenio.com'), 100000000)

Api.setAuthHeaders(getCookie('advenio_api_key')) // Attempt to set the auth token on app init

// Auth
const login = data => api.post('auth/login', data)
const refreshToken = data => api.post('auth/refresh', data)
const checkAuthorized = () => api.post('auth/access', { platform: 'companies' })
const impersonateUser = data => api.post('auth/impersonate', data)
const stopImpersonateUser = () => api.post('auth/stop-impersonating')

// Companies
const getCompanies = query => apiWithoutTimeout.get('companies/companies?deleted=true', { params: { ...query } })
const getAvailableCenters = id => api.get(`companies/companies/${id}/centers`)
const getOneCompany = id => api.get(`companies/companies/${id}?include=centers,contacts,contracts.products,contracts.products.extra_support,contracts.centers,contracts.limit_reservation,country,parents,invoice_details&deleted=true`)
const createCompany = data => api.post('companies/companies', data)
const updateCompany = (id, data) => api.patch(`companies/companies/${id}?include=centers,contacts,contracts,contracts.products,contracts.centers,contracts.limit_reservation,country,parents,invoice_details,`, data)
const removeCompany = id => api.delete(`companies/companies/${id}`)
const restoreCompany = id => api.put(`companies/companies/${id}/restore`)
const updateCompanyInvoiceDetails = (id, data) => api.patch(`companies/companies/${id}/invoice_details`, data)
const createCompanyContact = (company_id, data) => api.post(`companies/companies/${company_id}/contacts`, data)
const createContract = (id, data) => api.post(`companies/companies/${id}/contracts`, data)

// Company Accounts
const getCompanyAccount = ({ companyId, page }) => api.get(`companies/companies/${companyId}/account?page=${page}`)
const createPayment = (companyId, payment) => api.post(`companies/companies/${companyId}/payments?filter=paid`, payment)
const deletePayment = (companyId, payment) => api.delete(`companies/companies/${companyId}/payments/${payment}`)

// Contacts
const removeContact = id => api.delete(`companies/contact/${id}`)

// Contracts
const removeContract = id => api.delete(`companies/contract/${id}`)
const updateContract = (id, data) => api.patch(`companies/contract/${id}`, data)
const restoreContract = (id, data) => api.put(`companies/contract/${id}/restore`)

// Countries
const getCountries = () => api.get('countries?include=centers,country_products')

// ConsumbilesCatgory
const getConsumiblesCategory = () => api.get('consumable_categories')

// TODO
const getUsers = () => api.get('companies/users')
const postUserPicture = (id, data) => api.patch(`backend/users/${id}/profile-pic`, data)

const getPaymentTypes = () => api.get('companies/options/payment-types')
const resetPassword = data => api.post('auth/password/forgot', data)
const setNewPassword = (token, data) => api.post(`auth/password/${token}/reset`, data)
const validateToken = token => api.get(`auth/password/${token}`)
const getRegimenfiscal = () => api.get('options/sat/regimen-fiscal')
const getUsocFDI = () => api.get('options/sat/uso-cfdi')
const getCenters = () => api.get('/options/centers?include=currency')

/**
 * Create a collection of the previous functions to be exposed
 */
export default {
  auth: {
    login,
    refreshToken,
    checkAuthorized,
    impersonateUser,
    stopImpersonateUser,
    resetPassword,
    setNewPassword,
  },
  resetPassword: {
    get: validateToken,
  },
  companies: {
    get: getCompanies,
    getAvailableCenters,
    getOne: getOneCompany,
    create: createCompany,
    update: updateCompany,
    remove: removeCompany,
    restore: restoreCompany,
    updateInvoiceDetails: updateCompanyInvoiceDetails,
    createCompanyContact,
    createContract,
    getPaymentTypes,
  },
  companyAccount: {
    get: getCompanyAccount,
    createPayment,
    deletePayment,
  },
  contacts: {
    remove: removeContact,
  },
  contracts: {
    remove: removeContract,
    updateContract,
    restoreContract,
  },
  countries: {
    get: getCountries,
  },
  users: {
    get: getUsers,
    postUserPicture,
  },
  consumiblesCategory: {
    get: getConsumiblesCategory,
  },
  regimenFiscal: {
    get: getRegimenfiscal,
  },
  uso_cfdi: {

    get: getUsocFDI,

  },
  centers: {
    get: getCenters,
  },
}



// WEBPACK FOOTER //
// ./src/Data/Api.js